import type { CostumeId } from "./gallery";

export type SpineAssets = {
  id: string;
  label: string;
  skel: string;
  atlas: string;
  png: string;
};

export type SpinePack = SpineAssets & { id: CostumeId };

export const spinePacks: SpinePack[] = [
  {
    id: "default",
    label: "Default",
    skel: "/assets/spine/mondragon/default/MondragonM1908.skel",
    atlas: "/assets/spine/mondragon/default/MondragonM1908.atlas",
    png: "/assets/spine/mondragon/default/MondragonM1908.png",
  },
  {
    id: "costume1",
    label: "Repairer of Destiny",
    skel: "/assets/spine/mondragon/costume1/MondragonM1908_5704.skel",
    atlas: "/assets/spine/mondragon/costume1/MondragonM1908_5704.atlas",
    png: "/assets/spine/mondragon/costume1/MondragonM1908_5704.png",
  },
  {
    id: "costume2",
    label: "Evening Mist After The Rain",
    skel: "/assets/spine/mondragon/costume2/MondragonM1908_6304.skel",
    atlas: "/assets/spine/mondragon/costume2/MondragonM1908_6304.atlas",
    png: "/assets/spine/mondragon/costume2/MondragonM1908_6304.png",
  },
  {
    id: "costume3",
    label: "Magnolia Wonderland",
    skel: "/assets/spine/mondragon/costume3/MondragonM1908_8105.skel",
    atlas: "/assets/spine/mondragon/costume3/MondragonM1908_8105.atlas",
    png: "/assets/spine/mondragon/costume3/MondragonM1908_8105.png",
  },
];

/** Dorm chibis (R-suffix / *_chibi_dorm_*). Costumes reuse combat atlas/png. */
export const dormPacks: SpinePack[] = [
  {
    id: "default",
    label: "Default",
    skel: "/assets/spine/mondragon/default/Mondragon_chibi_dorm_skel.skel",
    atlas: "/assets/spine/mondragon/default/Mondragon_chibi_dorm_atlas.txt",
    png: "/assets/spine/mondragon/default/Mondragon_chibi_dorm_spritemap.png",
  },
  {
    id: "costume1",
    label: "Repairer of Destiny",
    skel: "/assets/spine/mondragon/costume1/Mondragon_costume1_chibi_dorm_skel.skel",
    atlas: "/assets/spine/mondragon/costume1/MondragonM1908_5704.atlas",
    png: "/assets/spine/mondragon/costume1/MondragonM1908_5704.png",
  },
  {
    id: "costume2",
    label: "Evening Mist After The Rain",
    skel: "/assets/spine/mondragon/costume2/Mondragon_costume2_chibi_dorm_skel.skel",
    atlas: "/assets/spine/mondragon/costume2/MondragonM1908_6304.atlas",
    png: "/assets/spine/mondragon/costume2/MondragonM1908_6304.png",
  },
  {
    id: "costume3",
    label: "Magnolia Wonderland",
    skel: "/assets/spine/mondragon/costume3/Mondragon_costume3_chibi_dorm_skel.skel",
    atlas: "/assets/spine/mondragon/costume3/MondragonM1908_8105.atlas",
    png: "/assets/spine/mondragon/costume3/MondragonM1908_8105.png",
  },
];

export const dinergatePack: SpineAssets = {
  id: "dinergate",
  label: "Dinergate",
  skel: "/assets/spine/dinergate/Dinergate_chibi_skel.skel",
  atlas: "/assets/spine/dinergate/Dinergate_chibi_atlas.txt",
  png: "/assets/spine/dinergate/Dinergate_chibi_spritemap.png",
};

export const spineConfig = {
  vendor: {
    pixi: "/vendor/pixi.min.js",
    pixiSpine: "/vendor/naganeko/pixi-spine-sjzs.js",
    skelBinary: "/vendor/naganeko/skb.js",
  },
  animations: {
    idle: ["wait", "wait1", "idle", "stand"],
    move: ["move", "move1", "walk", "run"],
    sit: ["sit", "sit1", "sit2", "rest"],
    pick: ["pick", "pick1", "touch"],
    lie: ["lying", "lie", "sleep", "lie1"],
    attack: ["attack", "attack1", "fire", "skill"],
    die: ["die", "die1", "die2", "die3", "dead"],
    victory: ["victory", "victory1", "victoryloop", "victoryloop1", "win"],
  },
  walkSpeed: 58,
  mobileWalkSpeed: 42,
  enemyWalkSpeed: 76,
  groundOffset: 8,
  desktopScale: 0.42,
  mobileScale: 0.28,
  enemyDesktopScale: 0.38,
  enemyMobileScale: 0.26,
  idleMs: [4200, 9000] as const,
  waveSize: [5, 6] as const,
  waveGapMs: [10000, 30000] as const,
  engageRange: 168,
  fireCooldownMs: 520,
  flashMs: 250,
  tracerSpeed: 2400,
  dieMs: 880,
  muzzleFlash: {
    src: "/assets/fx/muzzle-flash.png",
    cols: 4,
    rows: 4,
    scale: 0.16,
  },
};

export function pickClip(available: string[], aliases: string[]): string | null {
  const lower = available.map((n) => n.toLowerCase());
  for (const alias of aliases) {
    const i = lower.indexOf(alias.toLowerCase());
    if (i >= 0) return available[i] ?? null;
  }
  return available[0] ?? null;
}
